module.exports = __webpack_public_path__ + "img/img_box.138083bd.png";